import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const MILESTONE_IN_PROGRESS = 'In Progress';
export const MILESTONE_COMPLETED = 'Completed';
export const MILESTONE_WAITING_ON_CUSTOMER = 'Waiting on Customer';

export interface Subtask {
  title: string;
  dueDate?: Date;
  completionDate?: Date;
  status: string;
  notes?: string;
}

/**
 * @deprecated Use `project-tracker`: https://github.com/vendasta/galaxy/tree/master/libs/project-tracker
 */
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { VaIconModule } from './../va-icon/icon.module';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'uikit-project-milestones',
  templateUrl: './project-milestones.component.html',
  styleUrls: ['./project-milestones.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCardModule,
    MatExpansionModule,
    MatIconModule,
    MatProgressBarModule,
    VaIconModule,
    MarkdownModule,
  ],
})
export class ProjectMilestonesComponent implements OnInit {
  @Input() projectTitle: string;
  @Input() subtasks: Subtask[] = [];
  @Input() headerImageUrl = 'assets/images/project-milestones/no-banner.png';
  @Input() iconUrl: string | null = null;
  @Input() panelState = false;

  percentCompleted$$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  ngOnInit(): void {
    this.percentCompleted$$.next(
      (this.subtasks.filter((subtask) => subtask.status === MILESTONE_COMPLETED).length / this.subtasks.length) * 100,
    );
  }

  togglePanelState(): void {
    this.panelState = !this.panelState;
  }
}
